(() => {
  const ROOT_SELECTOR = '[data-sticky-atc]';

  const formatMoney = (cents, format) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }

    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  };

  const initStickyAddToCart = (root) => {
    if (!root || root.dataset.stickyAtcReady === 'true') return;

    const form = document.getElementById(root.dataset.formId);
    const section = document.getElementById(root.dataset.productSection);
    if (!form || !section) return;

    const originalButton = form.querySelector('[data-action="add-to-cart"]');
    const originalQuantity = form.querySelector('[name="quantity"]');
    const variantsNode = root.querySelector('[data-sticky-atc-variants]');
    if (!originalButton || !variantsNode) return;

    let variants = {};
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (error) {
      return;
    }

    root.dataset.stickyAtcReady = 'true';

    const sheet = document.querySelector(`[data-sticky-atc-sheet-for="${root.id}"]`);

    const elements = {
      image: root.querySelector('[data-sticky-atc-image]'),
      variant: root.querySelector('[data-sticky-atc-variant]'),
      price: root.querySelector('[data-sticky-atc-price]'),
      compare: root.querySelector('[data-sticky-atc-compare]'),
      save: root.querySelector('[data-sticky-atc-save]'),
      fitment: root.querySelector('[data-sticky-atc-fitment]'),
      quantity: root.querySelector('[data-sticky-atc-quantity]'),
      quantityInput: root.querySelector('[data-sticky-atc-quantity-input]'),
      decrease: root.querySelector('[data-sticky-atc-decrease]'),
      increase: root.querySelector('[data-sticky-atc-increase]'),
      button: root.querySelector('[data-sticky-atc-button]'),
      buttonLabel: root.querySelector('[data-sticky-atc-button-label]')
    };

    const sheetElements = sheet ? {
      image: sheet.querySelector('[data-sticky-atc-sheet-image]'),
      price: sheet.querySelector('[data-sticky-atc-sheet-price]'),
      compare: sheet.querySelector('[data-sticky-atc-sheet-compare]'),
      options: sheet.querySelector('[data-sticky-atc-options]'),
      quantityInput: sheet.querySelector('[data-sticky-atc-sheet-quantity]'),
      decrease: sheet.querySelector('[data-sticky-atc-sheet-decrease]'),
      increase: sheet.querySelector('[data-sticky-atc-sheet-increase]'),
      button: sheet.querySelector('[data-sticky-atc-sheet-button]'),
      buttonLabel: sheet.querySelector('[data-sticky-atc-sheet-button-label]'),
      open: root.querySelector('[data-sticky-atc-open-options]'),
      close: sheet.querySelectorAll('[data-sticky-atc-close-options]')
    } : {};

    const labels = {
      add: elements.buttonLabel ? elements.buttonLabel.textContent.trim() : 'Add to cart',
      soldOut: 'Sold Out',
      selectOptions: 'Select Options',
      checking: 'Checking fitment…',
      fits: 'Fits your vehicle',
      noFit: 'Does Not Fit'
    };

    const hasOptions = Object.keys(variants).length > 1;
    let currentVariant = null;
    let sourceWasSeen = false;
    let isSourceVisible = true;
    let isAdding = false;

    const selectedVariantId = () => {
      const idField = form.querySelector('[name="id"]');
      return idField ? String(idField.value) : '';
    };

    const setQuantity = (value, updateSource = true) => {
      const quantity = Math.max(1, parseInt(value, 10) || 1);
      if (elements.quantityInput) elements.quantityInput.value = quantity;
      if (sheetElements.quantityInput) sheetElements.quantityInput.value = quantity;
      if (updateSource && originalQuantity) {
        originalQuantity.value = quantity;
        originalQuantity.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    const scrollToSelector = () => {
      const target = form.querySelector('.product-form__variants, .product-form__option, [name="id"]');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const focusable = target.querySelector('input, select, button') || target;
        window.setTimeout(() => focusable.focus({ preventScroll: true }), 350);
      }
    };

    const getFitmentState = () => {
      const fitment = section.querySelector('#ymme-pdp-container');
      if (!fitment || root.dataset.showFitment !== 'true') return '';
      if (fitment.classList.contains('state-success')) return 'fit';
      // A warning means the selected variant does not fit even when another
      // variant of the same product might. Sticky ATC must not treat it as fit.
      if (fitment.classList.contains('state-error') || fitment.classList.contains('state-warning')) return 'no-fit';
      return 'checking';
    };

    const updateFitment = () => {
      const status = getFitmentState();
      if (!elements.fitment) return status;

      elements.fitment.className = 'sticky-atc__fitment';
      if (!status) {
        elements.fitment.hidden = true;
        return status;
      }

      elements.fitment.hidden = false;
      elements.fitment.classList.add(`is-${status}`);
      elements.fitment.textContent = status === 'fit' ? labels.fits : status === 'no-fit' ? labels.noFit : labels.checking;
      return status;
    };

    const updateButton = () => {
      const noFitBlocked = root.dataset.blockNoFit === 'true' && updateFitment() === 'no-fit';
      const unavailable = !currentVariant || currentVariant.available === false || originalButton.disabled;
      let disabled = false;
      let label = labels.add;

      if (!currentVariant && hasOptions) {
        label = labels.selectOptions;
      } else if (noFitBlocked) {
        disabled = true;
        label = labels.noFit;
      } else if (unavailable) {
        disabled = true;
        label = labels.soldOut;
      }

      elements.button.disabled = disabled;
      elements.buttonLabel.textContent = label;
      if (sheetElements.button) sheetElements.button.disabled = disabled;
      if (sheetElements.buttonLabel) sheetElements.buttonLabel.textContent = label;
    };

    const syncSheetOptions = () => {
      if (!sheetElements.options) return;

      sheetElements.options.innerHTML = '';
      form.querySelectorAll('.product-form__option:not(.no-js)').forEach((sourceOption, optionIndex) => {
        const clone = sourceOption.cloneNode(true);
        const idMap = new Map();

        clone.querySelectorAll('[id]').forEach((element, index) => {
          const oldId = element.id;
          const newId = `sticky-atc-option-${root.dataset.sectionId}-${optionIndex}-${index}`;
          idMap.set(oldId, newId);
          element.id = newId;
        });
        clone.querySelectorAll('label[for]').forEach((label) => {
          if (idMap.has(label.htmlFor)) label.htmlFor = idMap.get(label.htmlFor);
        });
        sheetElements.options.appendChild(clone);
      });
    };

    const closeSheet = () => {
      if (!sheet) return;
      sheet.hidden = true;
      sheet.setAttribute('aria-hidden', 'true');
      if (sheetElements.open) sheetElements.open.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('has-sticky-atc-sheet');
    };

    const openSheet = () => {
      if (!sheet) return;
      syncSheetOptions();
      sheet.hidden = false;
      sheet.setAttribute('aria-hidden', 'false');
      if (sheetElements.open) sheetElements.open.setAttribute('aria-expanded', 'true');
      document.body.classList.add('has-sticky-atc-sheet');
    };

    const updateVariant = (variant) => {
      currentVariant = variant && variants[String(variant.id)] ? { ...variant, ...variants[String(variant.id)] } : null;
      if (!currentVariant) currentVariant = variants[selectedVariantId()] || null;

      if (currentVariant) {
        if (elements.image && currentVariant.image) elements.image.src = currentVariant.image;
        if (sheetElements.image && currentVariant.image) sheetElements.image.src = currentVariant.image;
        if (elements.variant) {
          elements.variant.hidden = currentVariant.title === 'Default Title' || !currentVariant.title;
          elements.variant.textContent = currentVariant.title || '';
        }
        if (elements.price) elements.price.innerHTML = formatMoney(currentVariant.price, root.dataset.moneyFormat);
        if (sheetElements.price) sheetElements.price.innerHTML = formatMoney(currentVariant.price, root.dataset.moneyFormat);

        const comparePrice = Number(currentVariant.compare_at_price || 0);
        const price = Number(currentVariant.price || 0);
        const hasDiscount = comparePrice > price;
        if (elements.compare) {
          elements.compare.hidden = !hasDiscount;
          elements.compare.innerHTML = hasDiscount ? formatMoney(comparePrice, root.dataset.moneyFormat) : '';
        }
        if (sheetElements.compare) {
          sheetElements.compare.hidden = !hasDiscount;
          sheetElements.compare.innerHTML = hasDiscount ? formatMoney(comparePrice, root.dataset.moneyFormat) : '';
        }
        if (elements.save) {
          elements.save.hidden = !hasDiscount;
          elements.save.innerHTML = hasDiscount ? `SAVE ${formatMoney(comparePrice - price, root.dataset.moneyFormat)}` : '';
        }
      }

      syncSheetOptions();
      updateButton();
    };

    const syncFromSource = () => {
      setQuantity(originalQuantity ? originalQuantity.value : 1, false);
      updateVariant(variants[selectedVariantId()] || null);
    };

    const updateVisibility = () => {
      // Keep the product's original CTA as the first purchase action. The
      // sticky bar appears only after that CTA has entered the viewport once
      // and the customer continues scrolling past it.
      const shouldShow = sourceWasSeen && !isSourceVisible;
      root.hidden = !shouldShow;
      root.classList.toggle('is-visible', shouldShow);
      root.setAttribute('aria-hidden', String(!shouldShow));
      document.body.classList.toggle('has-sticky-atc', shouldShow);
      if (shouldShow) {
        document.documentElement.style.setProperty('--sticky-atc-height', `${root.offsetHeight}px`);
      } else {
        document.documentElement.style.removeProperty('--sticky-atc-height');
      }
    };

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      isSourceVisible = entry.isIntersecting;
      if (entry.isIntersecting) sourceWasSeen = true;
      updateVisibility();
    }, { threshold: 0.05 });
    observer.observe(originalButton);

    if (window.ResizeObserver) {
      new ResizeObserver(() => {
        if (!root.hidden) document.documentElement.style.setProperty('--sticky-atc-height', `${root.offsetHeight}px`);
      }).observe(root);
    }

    form.addEventListener('variant:changed', (event) => updateVariant(event.detail && event.detail.variant));
    document.addEventListener('variant:changed', (event) => {
      if (event.target === section) updateVariant(event.detail && event.detail.variant);
    });
    if (originalQuantity) originalQuantity.addEventListener('change', syncFromSource);

    if (elements.decrease) elements.decrease.addEventListener('click', () => setQuantity((elements.quantityInput ? elements.quantityInput.value : 1) - 1));
    if (elements.increase) elements.increase.addEventListener('click', () => setQuantity((elements.quantityInput ? elements.quantityInput.value : 1) + 1));
    if (elements.quantityInput) elements.quantityInput.addEventListener('change', () => setQuantity(elements.quantityInput.value));
    if (sheetElements.decrease) sheetElements.decrease.addEventListener('click', () => setQuantity((sheetElements.quantityInput ? sheetElements.quantityInput.value : 1) - 1));
    if (sheetElements.increase) sheetElements.increase.addEventListener('click', () => setQuantity((sheetElements.quantityInput ? sheetElements.quantityInput.value : 1) + 1));
    if (sheetElements.quantityInput) sheetElements.quantityInput.addEventListener('change', () => setQuantity(sheetElements.quantityInput.value));

    if (sheetElements.open) sheetElements.open.addEventListener('click', openSheet);
    if (sheetElements.close) sheetElements.close.forEach((button) => button.addEventListener('click', closeSheet));
    if (sheetElements.options) {
      sheetElements.options.addEventListener('change', (event) => {
        const control = event.target.closest('.product-form__single-selector');
        if (!control) return;

        const source = Array.from(form.querySelectorAll('.product-form__single-selector')).find((element) => (
          element.dataset.optionPosition === control.dataset.optionPosition && element.value === control.value
        ));
        if (!source) return;

        if (source.tagName === 'SELECT') source.value = control.value;
        else source.checked = control.checked;
        source.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    elements.button.addEventListener('click', () => {
      if (!currentVariant && hasOptions) {
        scrollToSelector();
        return;
      }
      if (elements.button.disabled || isAdding) return;

      isAdding = true;
      elements.button.classList.add('is-loading');
      originalButton.click();
      window.setTimeout(() => {
        isAdding = false;
        elements.button.classList.remove('is-loading');
        updateButton();
      }, 1500);
    });
    if (sheetElements.button) sheetElements.button.addEventListener('click', () => elements.button.click());

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && sheet && !sheet.hidden) closeSheet();
    });

    const fitmentElement = section.querySelector('#ymme-pdp-container');
    if (fitmentElement && root.dataset.showFitment === 'true') {
      new MutationObserver(updateButton).observe(fitmentElement, { attributes: true, attributeFilter: ['class'] });
    }

    syncFromSource();
  };

  const initAll = (scope = document) => scope.querySelectorAll(ROOT_SELECTOR).forEach(initStickyAddToCart);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  if (document.readyState !== 'loading') initAll();
})();
